import classNames from 'classnames';

import { getSearchQuery } from '../../utils/query';

import { YoutubeIsEmpty, YoutubeLayout, YoutubeProps } from './youtube.config';

export const Youtube = ({
  id,
  youtubeVideoId,
  layout,
  youtubeWidth,
  youtubeHeight,
  youtubeAspectRatio,
  youtubeAutoPlay,
  youtubeLoop,
  youtubeMute,
  youtubePlaysInline,
  youtubeRel,
  appliedCssClassNames,
  embeddableResourceType,
  accessibilityLabel,
  isInEditor,
  ...props
}: YoutubeProps) => {
  if (YoutubeIsEmpty({ isInEditor, youtubeVideoId, id, ...props })) {
    return null;
  }

  const playerParams = Object.entries({
    youtubeAutoPlay,
    youtubeLoop,
    youtubeMute,
    youtubePlaysInline,
    youtubeRel,
  }).map(([key, value]) => {
    const suffix = key.replace('youtube', '').toLowerCase();
    const propValue = value && !isInEditor ? '1' : '0';
    return `${suffix}=${propValue}`;
  });

  const queryparams = getSearchQuery(playerParams);

  const isResponsive = layout === YoutubeLayout.RESPONSIVE;

  return (
    <div
      data-testid="snowflake-youtube-embedded-wrapper"
      className={classNames(appliedCssClassNames, 'snowflake-youtube-embedded-wrapper', {
        'snowflake-youtube-embedded-wrapper-responsive': isResponsive,
      })}
      style={isResponsive ? { paddingTop: `${youtubeAspectRatio}%` } : {}}
    >
      <iframe
        tabIndex={0}
        data-testid="snowflake-youtube-embedded"
        className="snowflake-youtube-embedded"
        title={`Youtube Video ${youtubeVideoId}`}
        src={`https://www.youtube.com/embed/${youtubeVideoId}?playlist=${youtubeVideoId}&${queryparams}`}
        allowFullScreen
        width={youtubeWidth}
        height={youtubeHeight}
        style={{ maxHeight: `${youtubeHeight}px`, maxWidth: `${youtubeWidth}px` }}
        allow="autoplay; fullscreen"
        aria-label={accessibilityLabel}
      ></iframe>
    </div>
  );
};

export default Youtube;
